import React from 'react';
import {
  FormGroup,
  Col,
  Label,
  Input,
} from 'reactstrap';
const renderFieldInputText = ({
  name,
  input,
  label,
  inputs,
  type,
  placeholder,
  // meta: { touched, error, warning },
  meta: { touched, error, warning },
  display
}) => {

  const required = inputs.required === "true" ? true : false;

  if(type==="hidden"){
    return (<Input {...input} placeholder={placeholder} type={type} className={(touched && error && "error")}/>)
  }
  if(type==="dropdown"){
    return (<FormGroup row>
      <Col md="4"><Label htmlFor={name}>{label} { required ? <span>*</span> : <span></span>}</Label></Col>
      <Col md="8">

      <select required={required}> 
        {
          inputs.defaultValue?<option key={0} value={ inputs.defaultValue}>{ inputs.defaultValue}</option>:""
        }{
          inputs.typeOption.options?inputs.typeOption.options.map( ( optionItem, index)=>{
            return <option key={index} value={optionItem.value}>{optionItem.value}</option>
          }):""
        }
         
         </select>

        {touched &&
          ((error && <span className="error">{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </Col>
    </FormGroup>)
  }
  else{
  return (<FormGroup row>
    <Col md="4"><Label htmlFor={name}>{label} { required ? <span>*</span> : <span></span>}</Label></Col>
    <Col md="8">
      <Input {...input} placeholder={placeholder} type={type} className={(touched && error && "error")} required={required}/>
      {touched &&
        ((error && <span className="error">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </Col>
  </FormGroup>)}
}

  
;

export default renderFieldInputText;
